module.exports = __webpack_public_path__ + "img/tran_2kl.0f1fb924.jpg";